import { useState } from "react";

const InProductionModel = ({ isOpen, onClose, onSave }) => {
    const [file, setFile] = useState(null);

    if (!isOpen) return null;

    const handleFileChange = (e) => {
        setFile(e.target.files?.[0] ?? null);
    };

    const handleSubmit = () => {
        if (!file) return;
        onSave(file);
        setFile(null);
        onClose();
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-[9999]">
            <div className="bg-white rounded p-5 w-[90%] max-w-md">
                <h2 className="text-lg font-bold mb-4">Upload file for In-Production</h2>

                <label className="block text-sm font-medium mb-1">File_Upload</label>
                <input
                    name="File_Upload"
                    type="file"
                    accept="*/*"
                    onChange={handleFileChange}
                    className="w-full border p-2 rounded"
                />

                <div className="flex justify-end gap-2 mt-5">
                    <button className="bg-gray-400 text-white px-4 py-2 rounded" onClick={onClose}>
                        Cancel
                    </button>
                    <button
                        className={`px-4 py-2 rounded text-white ${file ? "bg-danger" : "bg-gray-300 cursor-not-allowed"}`}
                        onClick={handleSubmit}
                        disabled={!file}
                    >
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InProductionModel;
